export const formatLanguages = () => {
  const lang = window.navigator.language;
  const goodFormatLang = lang.slice(0, 2);

  return goodFormatLang;
};
